// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper_10qjt","dropdown":"Header_dropdown_Dh3pV"};